import * as React from "react";
import { FirebaseAuthContext } from "src/context/FirebaseAuthContext";

export default function useFirebaseAuth() {
  const context = React.useContext(FirebaseAuthContext);
  if (context === undefined) {
    throw new Error(
      "useFirebaseAuth must be used within a FirebaseAuthProvider"
    );
  }
  return context;
}
